export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/muze-bg.png?a30d6d596e75337df8c462fcae4dde10";